var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { when } from 'mobx';
import { Observer } from 'mobx-react-lite';
import React, { useRef } from 'react';
import Swiper from 'swiper';
import { useControllers } from '../../hooks/controller.hooks';
import { useOnMount } from '../../hooks/lifecycle.hooks';
import tick from '../../utils/wait.utils';
import SupportGroupCard from '../SupportGroupCard/SupportGroupCard';
import './SupportGroupSlides.scss';
var SupportGroupSlides = function (props) {
    var SUPPORT_GROUPS = useControllers().SUPPORT_GROUPS;
    useOnMount(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, SUPPORT_GROUPS.getLatestPublicSupportGroups()];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, tick()];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, when(function () { return !!ref.current; })];
                case 3:
                    _a.sent();
                    initSwiper();
                    return [2 /*return*/];
            }
        });
    }); });
    var ref = useRef(null);
    var initSwiper = function () {
        new Swiper(ref.current, {
            slidesPerView: 1.1,
            spaceBetween: 16,
            breakpoints: {
                480: { slidesPerView: 1.9 },
                768: { slidesPerView: 2.5 },
                1024: { slidesPerView: 3.3 },
                1280: { slidesPerView: 3.8 },
                1366: { slidesPerView: 4.2 },
                1440: { slidesPerView: 5.6 },
            }
        });
    };
    return React.createElement(Observer, { children: function () { return (React.createElement("div", { className: "SupportGroupSlides" },
            SUPPORT_GROUPS.errorGettingPublicSupportGroups && React.createElement("p", { className: "SupportGroupFeedErrorNotice" }, "Error getting information for support groups. Please try again later."),
            React.createElement("div", { className: "swiper-container", ref: ref },
                React.createElement("div", { className: "swiper-wrapper" }, SUPPORT_GROUPS.supportGroupSnapshots.map(function (g) { return React.createElement("div", { className: "swiper-slide", key: g.id },
                    React.createElement(SupportGroupCard, { supportGroup: g, redirectToApp: true })); }))))); } });
};
export default SupportGroupSlides;
